import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";

export const Backdrop = styled.div<{ zIndex?: number }>`
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    content: "";
    background: ${theme.colors.black};
    opacity: 0.4;
    z-index: ${theme.zIndex.overlay};

    ${({ zIndex }) =>
        zIndex &&
        css`
            z-index: ${zIndex};
        `};
`;

export default Backdrop;
